import React from 'react';

const Icon = (props: { color?: string }) => {
    return (
        <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M7.29419 14.1393C10.7704 14.1393 13.5884 11.2021 13.5884 7.57892C13.5884 3.95573 10.7704 1.01855 7.29419 1.01855C3.818 1.01855 1 3.95573 1 7.57892C1 11.2021 3.818 14.1393 7.29419 14.1393Z"
                stroke={props.color || '#757575'}
                strokeWidth="1.2"
                strokeLinecap="round"
            />
            <path d="M11.8242 12.6641L15.0008 15.9749L11.8242 12.6641Z" fill={props.color || '#757575'} />
            <path
                d="M11.8242 12.6641L15.0008 15.9749"
                stroke={props.color || '#757575'}
                strokeWidth="1.2"
                strokeLinecap="round"
            />
        </svg>
    );
};

export default Icon;
